var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verti"},[_c('section',{staticClass:"it-header"},[_c('div',{staticClass:"it-title weight-1"},[_vm._v("\n      "+_vm._s(_vm.$t('view.manage.companyList.title'))+"\n    ")])]),_c('section',{staticClass:"it-container"})])}
var staticRenderFns = []

export { render, staticRenderFns }